import { RequiredDocumentsHeadingEnum } from "./view-application-documentation-enums/view-application-documentation-enums";
export class ViewApplicationDocumentationConstants {
    static NO_DOCUMENT_REQUIRED_MESSAGE = "Documents are not required for this application, but you are welcome to submit any additional documents.";
    static NO_REQUIRED_DOCUMENTS_FOUND_MESSAGE = "No required documents found in the lookups, please contact system admin";
    static SESSION_DOCUMENTS_CANT_BE_DELETED_MESSAGE = "Only documents that were added in the current session can be deleted";
    static SESSION_DOCUMENTS_CANT_BE_EDITED_MESSAGE = "Only documents that were added in the current session can be edited";
    static UPLOAD_REQUIRED_DOC_LABEL = "Note: Upload the required documents for the application as listed below.";
    static UPLOAD_OPTIONAL_DOC_LABEL = "Note: Upload the optional documents for the application as listed below.";
    static OPTIONAL_DOCUMENTS_HEADER = "Optional documentation";
    static APPLICATIONS_DOCUMENTS_LABEL = "My application documents";
    static OPTIONAL_DOCUMENTS_LABEL = "Optional documentation";
    static ADD_DOCUMENTS_BTN_LABEL = "Add document";
    static ADD_DOCUMENTS_DIALOG_TITLE = "Add documents";
    static EDIT_DOCUMENTS_DIALOG_TITLE = "Edit documents";
    static DELETE_DOCUMENTS_DIALOG_TITLE = "Delete document(s)";
    static EDIT_DOCUMENTS_BTN_LABEL = "Edit document";
    static DELETE_DOCUMENTS_BTN_LABEL = "Delete document";
    static ATTACHMENT_LABEL = "Attachment";
    static DOWNLOAD_LABEL = "Download";
    static ADDITIONAL_APPLICATION_TYPE_CONSTANTS = "Additional";
    static IS_DOCUMENT_REQUIRED = "yes";
    static DOCUMENT_FORM_CONTROL_NAME = "documentForm";
    static DOCUMENTS_FORM_CONTROL_NAME = "documents";
    static DATE_PIPE_FORMAT = "dd/MM/yyyy hh:mm";
    static COMPONENT_NAME = "view-application-documentation";
    static modalBodyOptions = {
        size: "xl", centered: true, backdrop: "static"
    };
    static CLOSED_APPLICATION = "No documents can be edited or added on completed applications.";
    static REQUIRED_DOCUMENTS_HEADING_LOOKUP = new Map([
        [RequiredDocumentsHeadingEnum.type, "type"],
        [RequiredDocumentsHeadingEnum.name, "name"],
        [RequiredDocumentsHeadingEnum.dateUploaded, "dateUploaded"],
        [RequiredDocumentsHeadingEnum.fileName, "fileName"],
        [RequiredDocumentsHeadingEnum.source, "source"]
    ]);
}
